/*
 * Thumbnail gallery under product cards in the grid.
 *
 * Hovering or tapping a thumbnail swaps the main card image above it. Listeners are
 * delegated on document so cards injected later by section rendering (pagination,
 * filters) work without re-binding.
 */
(function () {
  function swapTo(thumb) {
    var card = thumb.closest('.product-card-wrapper');
    if (!card) return;

    var main = card.querySelector('[data-card-main-image]');
    if (!main) return;

    var full = thumb.getAttribute('data-full');
    if (!full || main.getAttribute('src') === full) return;

    main.setAttribute('src', full);

    var srcset = thumb.getAttribute('data-srcset');
    if (srcset) main.setAttribute('srcset', srcset);

    var thumbs = card.querySelectorAll('[data-card-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', thumbs[i] === thumb);
    }
  }

  // The whole card is an <a>, so a click on a thumbnail would otherwise open the product.
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-card-thumb]');
    if (!thumb) return;

    event.preventDefault();
    event.stopPropagation();
    swapTo(thumb);
  });

  // Hover is the primary interaction on desktop; mouseover bubbles, mouseenter does not,
  // which is what makes delegation possible here.
  document.addEventListener('mouseover', function (event) {
    var thumb = event.target.closest ? event.target.closest('[data-card-thumb]') : null;
    if (thumb) swapTo(thumb);
  });

  /* ---- Swipe on the photo itself (touch) ----------------------------------------------
     The thumbnails stay the desktop affordance; on a phone the natural gesture is dragging
     the big image. Both drive the same swapTo(), so the active thumbnail and the displayed
     photo cannot disagree.

     The whole card is an <a>, so the hard part is telling a swipe from a tap: a horizontal
     drag must change the photo WITHOUT opening the product, while a plain tap must still
     open it. We only suppress the click when the finger actually travelled. */

  var SWIPE_MIN = 40; // px of horizontal travel before it counts as a swipe, not a tap
  var startX = null;
  var startY = null;
  var swipedCard = null;

  function thumbsOf(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-card-thumb]'));
  }

  function stepCard(card, direction) {
    var thumbs = thumbsOf(card);
    if (thumbs.length < 2) return false;

    var current = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) current = i;
    }

    var next = current + direction;
    if (next < 0) next = thumbs.length - 1;
    if (next > thumbs.length - 1) next = 0;

    swapTo(thumbs[next]);
    return true;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length !== 1) return;
      var media = event.target.closest ? event.target.closest('.card__media') : null;
      if (!media) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      swipedCard = null;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (startX === null) return;

      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      startX = null;
      startY = null;

      // Vertical wins: the page must still scroll normally under a finger on a photo.
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;

      var media = event.target.closest ? event.target.closest('.card__media') : null;
      if (!media) return;

      var card = media.closest('.product-card-wrapper');
      if (card && stepCard(card, dx < 0 ? 1 : -1)) swipedCard = card;
    },
    { passive: true }
  );

  // Fires after touchend; cancels only the navigation that this swipe would have caused.
  document.addEventListener(
    'click',
    function (event) {
      if (!swipedCard) return;

      /* NOT THE BELL. This listener runs in the capture phase, so its stopPropagation() lands
         before the price-watch handler that is delegated on document further down — which meant
         that swiping a card's photo and then tapping "Jälgi hinda" swallowed the tap and opened
         nothing, and only a second tap worked. On a phone, where the swipe is the whole point of
         the gallery, that is the ordinary order of events rather than an edge case.

         Suppressing the swipe's click is only ever about the card's own <a>. Anything with a
         handler of its own is not what the finger dragged, so it is let through untouched. */
      if (event.target.closest && event.target.closest('[data-grid-price-watch]')) {
        swipedCard = null;
        return;
      }

      var card = event.target.closest ? event.target.closest('.product-card-wrapper') : null;
      if (card && card === swipedCard) {
        event.preventDefault();
        event.stopPropagation();
      }
      swipedCard = null;
    },
    true
  );
})();
